import React, { FC } from 'react';
import Actions from './Actions';
import {
  ActionsContainer,
  Button,
  ButtonsContainer,
  StatsContainer,
  SubHeaderContainer,
  ToolButton,
  ToolContainer,
} from './SubHeader.style';
import Summary from './Summary';
import {
  IDicom,
  IStudy,
  IStudyLabelingJob,
  IDicomLabelingJob,
  IReviewFrame,
  ISegmentationLabel,
} from 'models/icardio';

interface IProps {
  study: IStudy;
  studyLabelingJob?: IStudyLabelingJob;
  dicoms: IDicom[];
  checkIfDicomIsLabeled: any;
  previousButtonIsDisabled: any;
  nextButtonIsDisabled: any;
  previousReviewIsDisabled: boolean;
  nextReviewIsDisabled: boolean;
  onPreviousReview: () => void;
  onNextReview: () => void;
  identifierIsDisabled: any;
  identifierIsActive: any;
  setActiveTool: any;
  showPhaser: any;
  phaserIsDisabled: any;
  phaserIsActive: any;
  showKeypointer: any;
  keypointerIsDisabled: any;
  keypointerIsActive: any;
  showSegmentor: any;
  segmentorIsDisabled: any;
  segmentorIsActive: any;
  dicom: any;
  frames: any;
  activePhaseLabels: any;
  keypointCollectionLabels: any;
  dirtySegmentations: ISegmentationLabel[];
  activeViewLabel: any;
  activeQualityLabel: any;
  activeReviewFrame?: IReviewFrame;
  clearDirtySegmentations: () => void;
  setDataIsSaving: any;
  setErrorOccured: any;
  setViewLabelChangesAreSaved: any;
  setQualityLabelChangesAreSaved: any;
  setPhaseLabelLabelChangesAreSaved: any;
  setKeypointCollectionLabelLabelsChangesAreSaved: any;
  setSegmentationChangesAreSaved: any;
  setDicomJobChangesAreSaved: any;
  dicomLabelingJob: any;
  editMode: boolean;
  pageIsLoading: boolean;
  activeDicomLabelingJob?: IDicomLabelingJob;
  isReviewMode: boolean;
}

const SubHeader: FC<IProps> = props => {
  const {
    study,
    studyLabelingJob,
    dicoms,
    previousButtonIsDisabled,
    nextButtonIsDisabled,
    previousReviewIsDisabled,
    nextReviewIsDisabled,
    onPreviousReview,
    onNextReview,
    identifierIsDisabled,
    identifierIsActive,
    setActiveTool,
    showPhaser,
    phaserIsDisabled,
    phaserIsActive,
    showKeypointer,
    keypointerIsDisabled,
    keypointerIsActive,
    showSegmentor,
    segmentorIsDisabled,
    segmentorIsActive,
    dicom,
    frames,
    activePhaseLabels,
    keypointCollectionLabels,
    dirtySegmentations,
    activeViewLabel,
    activeQualityLabel,
    activeReviewFrame,
    clearDirtySegmentations,
    setDataIsSaving,
    setErrorOccured,
    setViewLabelChangesAreSaved,
    setQualityLabelChangesAreSaved,
    setPhaseLabelLabelChangesAreSaved,
    setKeypointCollectionLabelLabelsChangesAreSaved,
    setSegmentationChangesAreSaved,
    setDicomJobChangesAreSaved,
    dicomLabelingJob,
    editMode,
    pageIsLoading,
    activeDicomLabelingJob,
    isReviewMode,
  } = props;
  return pageIsLoading ? (
    <SubHeaderContainer>
      <StatsContainer />
      <ButtonsContainer />
      <ActionsContainer />
    </SubHeaderContainer>
  ) : (
    <SubHeaderContainer>
      <StatsContainer>
        <Summary study={study} studyLabelingJob={studyLabelingJob} dicoms={dicoms} />
      </StatsContainer>
      <ButtonsContainer>
        {isReviewMode ? (
          <Button
            disabled={previousReviewIsDisabled}
            onClick={previousReviewIsDisabled ? undefined : onPreviousReview}
          >
            PREVIOUS REVIEW
          </Button>
        ) : (
          !study.isIceStudy && <Button disabled={previousButtonIsDisabled}>(R) PREVIOUS</Button>
        )}
        <ToolContainer>
          {!isReviewMode && (
            <ToolButton
              disabled={identifierIsDisabled}
              active={identifierIsActive}
              type="identifier"
              onClick={() => setActiveTool('identifier')}
            >
              Identifier
            </ToolButton>
          )}
          {showPhaser && (
            <ToolButton
              disabled={phaserIsDisabled}
              active={phaserIsActive}
              type="phaser"
              onClick={() => setActiveTool('phaser')}
            >
              Phaser
            </ToolButton>
          )}
          {showKeypointer && (
            <ToolButton
              disabled={keypointerIsDisabled}
              active={keypointerIsActive}
              type="keypointer"
              onClick={() => setActiveTool('keypointer')}
            >
              Keypointer
            </ToolButton>
          )}
          {showSegmentor && (
            <ToolButton
              disabled={segmentorIsDisabled}
              active={segmentorIsActive}
              type="segmentor"
              onClick={() => setActiveTool('segmentor')}
            >
              Segmentor
            </ToolButton>
          )}
        </ToolContainer>
        {isReviewMode ? (
          <Button
            disabled={nextReviewIsDisabled}
            onClick={nextReviewIsDisabled ? undefined : onNextReview}
          >
            NEXT REVIEW
          </Button>
        ) : (
          !study.isIceStudy && <Button disabled={nextButtonIsDisabled}>(Y) NEXT</Button>
        )}
      </ButtonsContainer>
      <ActionsContainer>
        <Actions
          dicom={dicom}
          frames={frames}
          phaseLabels={activePhaseLabels}
          keypointCollectionLabels={keypointCollectionLabels}
          dirtySegmentations={dirtySegmentations}
          viewLabel={activeViewLabel}
          qualityLabel={activeQualityLabel}
          activeReviewFrame={activeReviewFrame}
          clearDirtySegmentations={clearDirtySegmentations}
          setDataIsSaving={setDataIsSaving}
          setErrorOccured={setErrorOccured}
          setViewLabelChangesAreSaved={setViewLabelChangesAreSaved}
          setQualityLabelChangesAreSaved={setQualityLabelChangesAreSaved}
          setPhaseLabelLabelChangesAreSaved={setPhaseLabelLabelChangesAreSaved}
          setKeypointCollectionLabelLabelsChangesAreSaved={
            setKeypointCollectionLabelLabelsChangesAreSaved
          }
          setSegmentationChangesAreSaved={setSegmentationChangesAreSaved}
          setDicomJobChangesAreSaved={setDicomJobChangesAreSaved}
          dicomLabelingJob={dicomLabelingJob}
          editMode={editMode}
          activeDicomLabelingJob={activeDicomLabelingJob}
          isReviewMode={isReviewMode}
        />
      </ActionsContainer>
    </SubHeaderContainer>
  );
};

export default SubHeader;
